/**
 * Youtube-shorts block
 *
 * Exposes a single static resource — `assets/to_normal.svg` — scoped to `*.youtube.com`.
 * Detectable only from YouTube (where it runs), via one CORS-free image load.
 *
 * Manifest verified against version 1.5.5.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jiaopdjbehhjgokpphdfgmapkobbnmjp';

export const youtubeShortsBlock: ExtensionDefinition = {
  id: ID,
  name: 'Youtube-shorts block',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  requiredOrigin: 'https://www.youtube.com',
  notes:
    'Single static WAR (assets/to_normal.svg) scoped to *.youtube.com, so only YouTube ' +
    'can detect it. Loads as an image, no CORS grant needed.',
  signals: [
    {
      id: 'war-to-normal-svg',
      kind: 'web-accessible-resource',
      description:
        'Load assets/to_normal.svg via <img> — the extension\'s toggle icon, exposed only ' +
        'to YouTube origins.',
      weight: 1,
      run: () => probeImage(ID, 'assets/to_normal.svg'),
    },
  ],
};
